import { render, staticRenderFns } from "./SubmitFeedback.vue?vue&type=template&id=767acf87&scoped=true"
import script from "./SubmitFeedback.vue?vue&type=script&lang=js"
export * from "./SubmitFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767acf87",
  null
  
)

export default component.exports